module.exports = __webpack_public_path__ + "img/年保服务.0e4c1962.png";